import { gql } from '@apollo/client';
import { GqlInvitation } from './invitation';

export interface GqlRole {
  organizationId: string;
  userId: string;
  personId: string;
  type: string;
  email: string;
}

export interface GqlOrganization {
  id: string;
  uuid: string;
  name: string;
  country: string;
  zipCode: string;
  timezone: string;
  timezoneIana: string;
  sport: string;
  businessType: string;
  plan: string;
  numberOfTeamsPaidFor: number;
  registrationType: string;
  paymentProvider: string;
  notes: string;
  mailingAddress: string;
  mailingAddress2: string;
  mailingCity: string;
  mailingState: string;
  mailingZip: string;
  mailingCountry: string;
  playerCount: number;
  invitations: GqlInvitation[];
  roles: GqlRole[];
  staff: any[];
  churnZeroId: string;
  disabled?: boolean;
  insertedAt?: string;
  isTest?: boolean;
  isTrial?: boolean;
  isInternalOrg?: boolean;
  currency: string;
  currencySymbol: string;
  isOrgV2: boolean;
}

export const GqlOrganizationFragment = gql`
  fragment OrganizationFields on Organization {
    __typename
    id
    uuid
    name
    country
    currency
    currencySymbol
    zipCode
    timezone
    timezoneIana
    sport
    businessType
    plan
    numberOfTeamsPaidFor
    registrationType
    paymentProvider
    notes
    mailingAddress
    mailingAddress2
    mailingCity
    mailingState
    mailingZip
    mailingCountry
    playerCount
    churnZeroId
    invitations {
      id
      email
      firstName
      lastName
      role
      status
    }
    roles {
      organizationId
      userId
      personId
      type
    }
    staff(filter: { roleType: owner }) {
      id
      firstName
      lastName
      emailAddress
      invitationStatus
      roles {
        type
        personId
        userId
      }
    }
    disabled
    insertedAt
    websiteUrl
    isTest
    isTrial
    hasCoachesPack
  }
`;

export const GqlBasicOrganizationFragment = gql`
  fragment BasicOrganizationFields on Organization {
    __typename
    id
    uuid
    name
    country
    zipCode
    timezone
    sport
    businessType
    plan
    numberOfTeamsPaidFor
    registrationType
    paymentProvider
    notes
    mailingAddress
    mailingAddress2
    mailingCity
    mailingState
    mailingZip
    mailingCountry
    playerCount
    churnZeroId
    isTest
    isTrial
    isInternalOrg
    disabled
    disabledMessage
    websiteUrl
    isOrgV2
  }
`;
